import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon';
import { IconSizes } from './helpers';
import { useTheme } from '../hooks';
import { Theme } from '../theme';
import { Platform, View } from 'react-native';
import { faCloud } from '@fortawesome/free-solid-svg-icons';

interface CloudIconProps {
  color?: string;
  size?: IconSizes;
}

const mapSizeToCode: { [key in IconSizes]: any } = {
  // On web, FA uses size codes but on native it uses numbers
  xl: Platform.OS === 'web' ? 'xl' : 48,
  lg: Platform.OS === 'web' ? 'lg' : 24,
  sm: undefined,
  xs: undefined
};

function getColor(color: string|undefined, theme: Theme) {
  if (color === 'primary') {
    return theme.palette.primary;
  }

  if (color === 'secondary') {
    return theme.palette.fadedIconColor;
  }

  if (color === 'secondaryLight') {
    return 'rgba(0,0,0,0.35)';
  }

  if (color === 'success') {
    return theme.palette.primary;
  }

  if (color === 'error') {
    return theme.palette.error;
  }

  return color || theme.palette.fadedIconColor;
}

const getScale = (size?: IconSizes) => {
  if (size === 'xl' || size === 'lg') {
    return 1.14;
  }
  return 1.22;
};

export const CloudIcon = (props: CloudIconProps) => {
  const theme = useTheme();
  const color = getColor(props.color, theme);
  const iconSize = props.size ? mapSizeToCode[props.size] : undefined;
  const outlineScale = getScale(props.size);
  const outlineTransform = { transform: [{ scaleX: outlineScale, scaleY: outlineScale }] };

  return (
    <View
      style={{ position: 'relative', alignItems: 'center', justifyContent: 'center' }}
    >
      <FontAwesomeIcon
        icon={faCloud}
        size={iconSize}
        color={color}
        style={{
          position: 'absolute',
          opacity: 0.45,
          ...outlineTransform,
        }}
      />
      <FontAwesomeIcon
        icon={faCloud}
        size={iconSize}
        color={color}
      />
    </View>
  );
};
